import MessageTypes from "enums/message-types";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import { Grid, Card } from "@mui/material";
import { connect } from "react-redux";
import Swal from "sweetalert2";

import { useHistory } from "react-router-dom";
import initialValues from "layouts/organization/components/organization-details/schemas/organizationFormInitialValues";
import validations from "layouts/organization/components/organization-details/schemas/organizationFormValidations";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import initialForm from "layouts/organization/components/organization-details/schemas/organizationForm";
import localizeForm from "layouts/organization/components/organization-details/schemas/organizationLocalizeForm";
import { removeMessage } from "redux/actions/message";

import { startNewOrganizationScreen, saveOrganization } from "redux/actions/pages";
import OrganizationForm from "../OrganizationForm";

const OrganizationDetails = ({
  organization,
  saveNewOrganization,
  startScreen,
  message,
  removeErrorMsg,
  localizations,
}) => {
  const [form, setForm] = useState(initialForm);
  const history = useHistory();

  useEffect(() => {
    startScreen();
  }, []);

  useEffect(() => {
    if (localizations) {
      setForm(localizeForm(form, localizations));
    }
  }, [localizations]);

  useEffect(() => {
    if (
      message &&
      message.messageContent !== undefined &&
      message.messageContent !== null &&
      message.messageContent !== ""
    ) {
      Swal.fire({
        icon: message.messageType || "error",
        title:
          message.messageType === MessageTypes.success
            ? localizations?.MESSAGE_SUCCESS
            : localizations?.MESSAGE_ERROR,
        text: message.messageContent,
        showCancelButton: false,
        confirmButtonText:
          localizations?.MESSAGE_GO_ORGANIZATION_LIST_BTN ?? "Organizasyon Listesine Git",
      }).then(() => {
        removeErrorMsg();
        history.push("/organization");
      });
    }
  }, [message]);

  const getInitialValues = () => {
    if (organization && organization?.id > 0) {
      return {
        organizationKey: organization.organizationKey || "",
        isPhonicsEnabled: organization.isPhonicsEnabled || false,
      };
    }
    return initialValues;
  };

  const handleSubmit = (values, actions) => {
    const formattedValues = {
      organizationKey: values.organizationKey ?? "",
      isPhonicsEnabled: values.isPhonicsEnabled ?? false,
    };

    if (organization && organization.id > 0) {
      formattedValues.id = organization.id;
    }
    saveNewOrganization({ organization: { ...formattedValues } });

    actions.setSubmitting(false);
    actions.resetForm();
  };

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={getInitialValues()}
        validationSchema={validations.validation}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          isSubmitting,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Form id={form.formId} autoComplete="off">
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <Card sx={{ overflow: "visible" }}>
                  <SuiBox p={3}>
                    <OrganizationForm
                      formData={{
                        formField: form.formField,
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        setFieldValue,
                        setFieldTouched,
                      }}
                    />
                    <SuiBox display="flex" my={5}>
                      <SuiBox ml="auto">
                        <SuiButton
                          disabled={isSubmitting}
                          type="submit"
                          variant="contained"
                          color="dark"
                          size="small"
                        >
                          {localizations?.FORM_SAVE_BTN}
                        </SuiButton>
                      </SuiBox>
                    </SuiBox>
                  </SuiBox>
                </Card>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};

OrganizationDetails.defaultProps = {
  localizations: null,
  message: null,
  organization: null,
};

OrganizationDetails.propTypes = {
  localizations: PropTypes.objectOf(PropTypes.any),
  message: PropTypes.objectOf(PropTypes.any),
  removeErrorMsg: PropTypes.func.isRequired,
  startScreen: PropTypes.func.isRequired,
  saveNewOrganization: PropTypes.func.isRequired,
  organization: PropTypes.objectOf(PropTypes.any),
};

const mapStateToProps = (state) => ({
  localizations: state.localization?.pairs,
});

const mapDispatchToProps = {
  removeErrorMsg: removeMessage,
  startScreen: startNewOrganizationScreen,
  saveNewOrganization: saveOrganization,
};
export default connect(mapStateToProps, mapDispatchToProps)(OrganizationDetails);
